import React from "react";
import PropTypes from "prop-types";

/**
 * The labelled field used across the POS — the same construction as the Sales
 * Invoice modal's `si-field`, so the two screens read as one product: an icon
 * tile, a bordered box, and the label notched into the top border.
 */
const POSField = ({ icon, label, children, action, className = "" }) => (
  <div className={`pos-field ${className}`.trim()}>
    {icon ? <span className="pos-field__icon">{icon}</span> : null}
    <div className="pos-field__box">
      <label className="pos-field__label">{label}</label>
      {children}
    </div>
    {action}
  </div>
);

POSField.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node.isRequired,
  children: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
};

export default POSField;
